import { createOrGetFetchedState } from '@vista-digital/utilities';
import { ocapiClient } from '../../../../api-clients/ocapi/client';
import { getCacheDuration } from '../../../../utils/get-cache-duration';
import { loadDataFromApi } from '../../../../utils/load-data-from-api';
import { browsingDomainStore } from '../../store';
import { onFilmListLoadSuccess } from './utils/on-success';
export const loadFilmsForSite = async (siteId, reloadCachedData = false) => {
    const state = createOrGetFetchedState(browsingDomainStore.data.filmIdsBySiteId, siteId);
    await loadDataFromApi({
        api: () => ocapiClient.instance.v1.browsing.masterData.films.getForSite(siteId),
        state,
        cacheDuration: getCacheDuration('films'),
        onSuccess: onFilmListLoadSuccess,
        reloadCachedData
    });
};
//# sourceMappingURL=load-films-for-site.js.map